import { useScript } from "../../home/useScript"
import { Link } from "react-router-dom"
import RouterNavButton from "../../../features/button/routernavbutton"
import { DefaultBottomDialogue } from "../../../features"

export const BedsideProceduresPage = ({ children }) => {
    useScript('/script.js')
    return (
        <>
            {/* <!--Hero--> */}
            <div className="pt-2">
                <div className="container mx-auto flex flex-wrap flex-col items-center">

                    <div className="border px-2 w-[350px] md:w-fit md:min-h-[330px] rounded-2xl bg-white bg-opacity-20 container flex flex-wrap flex-col items-center">


                        <h3 className="px-4 text-center font-bold my-4 text-2xl mx-auto leading-tight">
                            Bedside Procedures That You Must Know
                        </h3>
                        <div className="px-4 grid grid-cols-2 gap-x-2 md:gap-x-24 w-fit md:w-[700px] mb-10">




                            <Link to='ivsampling'>

                                <RouterNavButton>
                                    Intravenous Sampling
                                </RouterNavButton>
                            </Link>


                            <Link to='arterialsampling'>
                                <RouterNavButton>
                                    Arterial Sampling
                                </RouterNavButton>
                            </Link>

                            <Link to='ivcannulation'>
                                <RouterNavButton>
                                    Intravenous Access/Line
                                </RouterNavButton>
                            </Link>

                            <Link to='centralvenousline'>
                                <RouterNavButton>
                                    Central Venous Line
                                </RouterNavButton>
                            </Link>
                            <Link to='urinarycatheterization'>
                                <RouterNavButton>
                                    Urinary Catheterization
                                </RouterNavButton>
                            </Link>

                            <Link to='urinarysampling'>
                                <RouterNavButton>
                                    Urinary Sampling
                                </RouterNavButton>
                            </Link>

                            <Link to='nasogastrictube'>
                                <RouterNavButton>
                                    Nasogastric Tube
                                </RouterNavButton>
                            </Link>

                            <Link to='lumbarpuncture'>
                                <RouterNavButton>
                                    Lumbar Puncture
                                </RouterNavButton>
                            </Link>



                        </div>











                        {/* <!--Right Col--> */}
                        {children}
                    </div>
                </div>
                <div className="grid w-auto mb-6">
                    <DefaultBottomDialogue />
                </div>
            </div>
            <div className="relative -mt-12 lg:-mt-24">
                <svg viewBox="0 0 1428 174" version="1.1" xmlns="http://www.w3.org/2000/svg"
                >
                    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                        <g transform="translate(-2.000000, 44.000000)" fill="#FFFFFF" fillRule="nonzero">
                            <path
                                d="M0,0 C90.7283404,0.927527913 147.912752,27.187927 291.910178,59.9119003 C387.908462,81.7278826 543.605069,89.334785 759,82.7326078 C469.336065,156.254352 216.336065,153.6679 0,74.9732496"
                                opacity="0.100000001"></path>
                            <path
                                d="M100,104.708498 C277.413333,72.2345949 426.147877,52.5246657 546.203633,45.5787101 C666.259389,38.6327546 810.524845,41.7979068 979,55.0741668 C931.069965,56.122511 810.303266,74.8455141 616.699903,111.243176 C423.096539,147.640838 250.863238,145.462612 100,104.708498 Z"
                                opacity="0.100000001"></path>
                            <path
                                d="M1046,51.6521276 C1130.83045,29.328812 1279.08318,17.607883 1439,40.1656806 L1439,120 C1271.17211,77.9435312 1140.17211,55.1609071 1046,51.6521276 Z"
                                id="Path-4" opacity="0.200000003"></path>
                        </g>
                        <g transform="translate(-4.000000, 76.000000)" fill="#FFFFFF" fillRule="nonzero">
                            <path
                                d="M0.457,34.035 C57.086,53.198 98.208,65.809 123.822,71.865 C181.454,85.495 234.295,90.29 272.033,93.459 C311.355,96.759 396.635,95.801 461.025,91.663 C486.76,90.01 518.727,86.372 556.926,80.752 C595.747,74.596 622.372,70.008 636.799,66.991 C663.913,61.324 712.501,49.503 727.605,46.128 C780.47,34.317 818.839,22.532 856.324,15.904 C922.689,4.169 955.676,2.522 1011.185,0.432 C1060.705,1.477 1097.39,3.129 1121.236,5.387 C1161.703,9.219 1208.621,17.821 1235.4,22.304 C1285.855,30.748 1354.351,47.432 1440.886,72.354 L1441.191,104.352 L1.121,104.031 L0.457,34.035 Z">
                            </path>
                        </g>
                    </g>
                </svg>
            </div>

            {/* <!-- Change the colour #f8fafc to match the previous section colour --> */}
            <svg className="wave-top" viewBox="0 0 1439 147" version="1.1" xmlns="http://www.w3.org/2000/svg"
            >
                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g transform="translate(-1.000000, -14.000000)" fillRule="nonzero">
                        <g className="wave" fill="#f8fafc">
                            <path
                                d="M1440,84 C1383.555,64.3 1342.555,51.3 1317,45 C1259.5,30.824 1206.707,25.526 1169,22 C1129.711,18.326 1044.426,18.475 980,22 C954.25,23.409 922.25,26.742 884,32 C845.122,37.787 818.455,42.121 804,45 C776.833,50.41 728.136,61.77 713,65 C660.023,76.309 621.544,87.729 584,94 C517.525,105.104 484.525,106.438 429,108 C379.49,106.484 342.823,104.484 319,102 C278.571,97.783 231.737,88.736 205,84 C154.629,75.076 86.296,57.743 0,32 L0,0 L1440,0 L1440,84 Z">
                            </path>
                        </g>
                        <g transform="translate(1.000000, 15.000000)" fill="#FFFFFF">
                            <g transform="translate(719.500000, 68.500000) rotate(-180.000000) translate(-719.500000, -68.500000) ">
                                <path
                                    d="M0,0 C90.7283404,0.927527913 147.912752,27.187927 291.910178,59.9119003 C387.908462,81.7278826 543.605069,89.334785 759,82.7326078 C469.336065,156.254352 216.336065,153.6679 0,74.9732496"
                                    opacity="0.100000001"></path>
                                <path
                                    d="M100,104.708498 C277.413333,72.2345949 426.147877,52.5246657 546.203633,45.5787101 C666.259389,38.6327546 810.524845,41.7979068 979,55.0741668 C931.069965,56.122511 810.303266,74.8455141 616.699903,111.243176 C423.096539,147.640838 250.863238,145.462612 100,104.708498 Z"
                                    opacity="0.100000001"></path>
                                <path
                                    d="M1046,51.6521276 C1130.83045,29.328812 1279.08318,17.607883 1439,40.1656806 L1439,120 C1271.17211,77.9435312 1140.17211,55.1609071 1046,51.6521276 Z"
                                    opacity="0.200000003"></path>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
            <section className="container mx-auto text-center py-6 mb-12">
                <h2 className="px-4 w-full my-2 text-4xl md:text-5xl font-bold leading-tight text-center text-white">
                    Connect with us!
                </h2>
                <div className="w-full mb-4">
                    <div className="h-1 mx-auto bg-white w-1/6 opacity-25 my-0 py-0 rounded-t"></div>
                </div>
                <h3 className="my-4 px-8 text-2xl md:text-3xl leading-tight">
                    Keep getting latest feature updates on Instagram
                </h3>
                <div className="flex place-content-center">
                    <a href='http://www.instagram.com/first.scrub' target="_blank" rel="noreferrer">
                        <button
                            className="mx-auto flex gap-x-4 lg:mx-0 hover:underline bg-white text-gray-800 font-bold rounded-full my-6 py-4 px-10 shadow-lg focus:outline-none focus:shadow-outline transform transition hover:scale-105 duration-300 ease-in-out">

                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="h-8 text-black w-8"
                                viewBox="0 0 24 24">
                                <path
                                    d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                            </svg>
                            @first.scrub
                        </button>
                    </a>
                </div>
            </section>


        </>
    )
}